import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleSquareFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.002 10.002v-.004c.007-.962.036-1.824.098-2.595C1.55 1.877 3.726 1 12 1c9.625 0 11 1.188 11 9.5 0 8.313-1.375 9.5-11 9.5-1.93 0-3.527-.048-4.85-.191L1 23V10zM7 9.3V7.5h10v1.8zm0 2.2h8v1.8H7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BubbleSquareFilledSize24Glyph.displayName = 'BubbleSquareFilledSize24Glyph';
